import Document from "../components/Document";

export default function InstructionPage() {
    const instructionUrl = 'https://drive.google.com/file/d/1mPkeOI4cVZtm0ecOca3lwM9uM54c4Na0/preview';
    return (
        <Document url={instructionUrl} title='Instruction' />
    )
}